import { useMutation, useQueryClient } from 'react-query';
import {
  pauseBettieAutoTopUp,
  type PauseBettieAutoTopUpResponse
} from '../../services/bettieAutoTopUpService';

export function usePauseBettieAutoTopUp() {
  const queryClient = useQueryClient();
  return useMutation<PauseBettieAutoTopUpResponse, Error, string>(pauseBettieAutoTopUp, {
    onSuccess: () => {
      queryClient.invalidateQueries(['bettieAutoTopUp']);
    }
  });
}
